/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import PracticeHubAccountStatus from './PracticeHubAccountStatus/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ContactInfo({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem/ContactInfo"
  
}) {
let professionalOtherPersonValueData = fromData.useDataFormat({ viewPath,
context: 'professional',
path: 'other.person',
format: fromHelpers.getContactInfo,
})
  return (<React.Fragment
>
<div
  data-testid="ContactInfo.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="professional.other.person"
 format="helpers.js getContactInfo"
 text={professionalOtherPersonValueData}
/>
<PracticeHubAccountStatus
  viewPath={`${viewPath}/PracticeHubAccountStatus`}
/>
</div>
{children}
</React.Fragment>)
}